import * as api from "../../../APICalls/index";

const getAuthErrorMessage = (error: any, fallbackMessage: string) => {
  const status = error?.response?.status;
  const data = error?.response?.data;

  const message =
    data?.message ||
    data?.error ||
    (typeof data === "string" ? data : "") ||
    (status === 404
      ? "Password reset is not available in this environment."
      : fallbackMessage);

  return {
    message,
    status,
  };
};

const normalizeEmail = (email: string) => email.toLowerCase().trim();

export const forgotPassword = (formData: { email: string }) => async () => {
    try {
      const email = normalizeEmail(formData.email);
      const response = await api.ForgotPassword({ email, type: "otp" });

      if (response.status === 200) {
        return {
          data: response.data,
          success: true,
          message: "Email Sent Successfully",
        };
      }

      return {
        data: response.data,
        success: false,
        message: response.data?.message || "Failed to send reset email.",
      };
    } catch (error: any) {
      const { message, status } = getAuthErrorMessage(
        error,
        "Failed to send reset email."
      );

      return {
        success: false,
        error: "Failed to send reset email",
        message,
        status,
      };
    }
  };